// extracted by mini-css-extract-plugin
export var statItem = "_gg-1";
export var statsRow = "_gg-0";